import { Field } from "formik";
import { useField } from "formik";

export default function Select({ label, children, errorClass, ...props }) {
  const [field, meta] = useField(props);

  return (
    <div>
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {label}
      </label>
      <Field
        as="select"
        {...field}
        {...props}
        className="backdrop-blur block w-full p-2 mb-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50/50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700/70 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      >
        {children}
      </Field>
      {meta.touched && meta.error ? (
        <p
          className={`text-sm my-4 text-red-900 dark:text-red-400 ${errorClass}`}
        >
          {meta.error}
        </p>
      ) : null}
    </div>
  );
}
